import React from "react";

const OrderDetailsSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 animate-pulse">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="bg-white dark:bg-neutral-800 rounded-2xl shadow-sm border border-gray-100 dark:border-neutral-700 p-5 flex items-center gap-4">
          <div className="w-10 h-10 rounded-xl bg-gray-200 dark:bg-neutral-700 shrink-0" />
          <div className="flex flex-col gap-2 flex-1">
            <div className="h-3 w-20 bg-gray-200 dark:bg-neutral-700 rounded" />
            <div className="h-6 w-28 bg-gray-100 dark:bg-neutral-600 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderDetailsSkeleton;
